var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4.33333H22.1929C21.7286 1.84167 19.8714 0 17.6429 0C15.4143 0 13.5571 1.84167 13.0929 4.33333H0V6.5H13.0929C13.5571 8.99167 15.4143 10.8333 17.6429 10.8333C19.8714 10.8333 21.7286 8.99167 22.1929 6.5H26V4.33333ZM17.6429 8.66667C16.0643 8.66667 14.8571 7.25833 14.8571 5.41667C14.8571 3.575 16.0643 2.16667 17.6429 2.16667C19.2214 2.16667 20.4286 3.575 20.4286 5.41667C20.4286 7.25833 19.2214 8.66667 17.6429 8.66667ZM0 21.6667H3.80714C4.27143 24.1583 6.12857 26 8.35714 26C10.5857 26 12.4429 24.1583 12.9071 21.6667H26V19.5H12.9071C12.4429 17.0083 10.5857 15.1667 8.35714 15.1667C6.12857 15.1667 4.27143 17.0083 3.80714 19.5H0V21.6667ZM8.35714 17.3333C9.93571 17.3333 11.1429 18.7417 11.1429 20.5833C11.1429 22.425 9.93571 23.8333 8.35714 23.8333C6.77857 23.8333 5.57143 22.425 5.57143 20.5833C5.57143 18.7417 6.77857 17.3333 8.35714 17.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f1f2a3a46854d8c274b00292abb280df.svg";
export { ForwardRef as ReactComponent };